import {locationStore} from "./locationStore";

export const useLocation = locationStore;
